import React, { useEffect, useState } from "react";
import axiosConfig from "../../Service/axiosConfig";
import { MdDeleteOutline } from "react-icons/md";
import DataTable from "react-data-table-component";
import { DeletePopupModal, PopupModal } from "../../Components";
import AlertDeletePopupModal from "../../Components/PopupModal/AlertDeletePopupModal";
import "../../Pages/master_categories.css";
import {
  MdKeyboardArrowUp,
  MdKeyboardArrowDown,
  MdDelete,
} from "react-icons/md";
import { FiSave } from "react-icons/fi";
import { FileManager } from "../../Components/FileManager";
import Select from "react-select";
import { FaHandHoldingHeart } from "react-icons/fa";
import tableCustomStyles from "../PopupModal/tableCustomStyles";
const CategorySection = ({
  id,
  selectedhomepageId,
  categorySecId,
  is_suspended,
  getTemplate
}) => {
  const [AlertDeletePopupType, SetAlertDeletePopupType] = useState("");
  const [deletePopupType, setDeletepopupType] = useState("");
  const [loading, setLoading] = useState(false);
  const [RowId, SetRowId] = useState();
  const [RowPerPage, setRowPerPage] = useState(20);
  const [selectedRows, setSelectedRows] = useState([]);
  const [Error, SetError] = useState();
  const [popupType, setpopupType] = useState("");
  const [sortedBanners, setSortedBanners] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);
  const [search, SetSearch] = useState({
    search: "",
  });
  const [Data, SetData] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [modalShow, setModalShow] = useState(false);
  const [Message, SetMessage] = useState("");
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [formData, setFormData] = useState({});
  const fetchAllCategories = async () => {
    setLoading(true);
    try {
      const [categoryRes, promoRes] = await Promise.all([
        axiosConfig("catlog/categories/?page_size=150&is_suspended=false"),
        // axiosConfig("/cms/promotional_category/?page_size=150&is_suspended=false")
      ])
      // const normal_category = categoryRes.data.results.map((ele) => ({
      //   value: ele.id,
      //   label: ele.name,
      //   title: "categorie"
      // }))
      const uniqueCategories = Object.values(
        categoryRes.data.results.reduce((acc, item) => {
          const key = item.name.toLowerCase().trim();

          if (
            !acc[key] ||
            item.source_type === "category"
          ) {
            acc[key] = item;
          }

          return acc;
        }, {})
      );

      const normal_category = uniqueCategories.map((ele) => ({
        value: ele.id,
        label: ele.name,
        title:
          ele.source_type === "promotional_category"
            ? "promotional_categorie"
            : "categorie"
      }));
      // const promo_category = promoRes.data.results.map((ele) => ({
      //   value: ele.id,
      //   label: ele.title,
      //   title: "promotional_categorie"
      // }))
      // setCategoryOptions([...normal_category, ...promo_category])
      setCategoryOptions([...normal_category])
    } catch (error) {
      console.log(error)
      setCategoryOptions([])
    } finally {
      setLoading(false)
    }
  }
  useEffect(() => {
    fetchAllCategories()
  }, []);
  const GetData = async (sectionId = categorySecId) => {
    if (!sectionId) return;

    setLoading(true);
    try {
      const response = await axiosConfig.get(
        `/cms/get_homepagedesign/?section_id=${sectionId}`
      );

      const flattenedCategories = (response?.data?.results || []).flatMap((section) => {
        const normalCategories = (section?.category || []).map((category) => ({
          ...category,
          item_type: "category",
          section_id: section.id,
          section_title: section.title,
        }));
        const promotionalCategories = (section?.promotional_category || []).map((promoCategory => ({
          ...promoCategory,
          item_type: "promotional_category",
          section_id: section.id,
          section_title: section.title,
        })));
        return [...normalCategories, ...promotionalCategories];
      });

      SetData(flattenedCategories);
      setTotalRows(flattenedCategories.length);

    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    if (categorySecId) {
      GetData(categorySecId);
    }
  }, [categorySecId]);


  console.log(Data, "kljm");
  const handleCategoryChange = (selectedOptions) => {
    setSelectedCategories(selectedOptions);
  };
  const handleImageChange = (files) => {
    const file = files[0].image;
    const file_key = files[0].id;
    setSelectedImage(file);
    setFormData({ ...formData, ["image"]: file_key });
  };

  const handleSort = (column, direction, newOrder) => {
    setSortedBanners(newOrder);
    axiosConfig
      .get(
        `catlog/categories/?ordering=${direction === "asc" ? column.selector : -column.selector
        }`
      )
      .then((res) => {
        SetData(res.data.results);
      })
      .catch((error) => {
        console.log(error);
      });
    setCurrentPage(1);
  };
  const handleRowSelected = ({ selectedRows }) => {
    setSelectedRows(selectedRows);
  };

  const handleSaveSelected = async () => {
    if (!selectedCategories.length) return;

    try {
      const categoryIds = selectedCategories
        .filter((item) => item.title === "categorie")
        .map((item) => item.value);

      const promoIds = selectedCategories
        .filter((item) => item.title === "promotional_categorie")
        .map((item) => item.value);

      if (categorySecId) {
        const requests = [];

        if (categoryIds.length > 0) {
          requests.push(
            axiosConfig.post(
              `/cms/homepage_template/${categorySecId}/add_items/`,
              {
                item_type: "category",
                item_ids: categoryIds,
              }
            )
          );
        }

        if (promoIds.length > 0) {
          requests.push(
            axiosConfig.post(
              `/cms/homepage_template/${categorySecId}/add_items/`,
              {
                item_type: "promotional_category",
                item_ids: promoIds,
              }
            )
          );
        }

        await Promise.all(requests);

        await GetData(categorySecId);
        await getTemplate()
      }

      else {
        const response = await axiosConfig.post(
          `/cms/homepage_template/`,
          {
            home_page: selectedhomepageId,
            title: "Categorie",
            category: categoryIds,
            promotional_category: promoIds,
            sort: id,
          }
        );

        const newSectionId = response?.data?.id;

        if (newSectionId) {
          await GetData(newSectionId);
          await getTemplate()
        }
      }

      SetMessage("Items saved successfully");
      setpopupType("success");

    } catch (error) {
      SetError("Error saving template");
      setpopupType("error");
      console.error(error);
    }
  };

  const columns = [
    {
      name: "S.No",
      selector: "id",
      cell: (row, i) => (currentPage - 1) * RowPerPage + i + 1,
      sortable: true,
    },
    {
      name: "Category Name",
      selector: "name",
      cell: (row) => row.name || row.title,
      sortable: true,
    },
    {
      name: "Category Image",
      selector: "image__image",
      cell: (row) => (
        <img src={row.image__image || row.image} alt={row.name} style={{ width: "100px" }} />
      ),
      sortable: false,
    },
    {
      name: "Category Slug",
      selector: "cat_slug",
      cell: (row) => row.cat_slug || row.slug,
      sortable: true,
    },
    {
      name: "Section Title",
      selector: "section_title",
      cell: (row) => row.section_title,
      sortable: true,
    },
    {
      name: "Section ID",
      selector: "section_id",
      cell: (row) => row.section_id,
      sortable: true,
    },
    {
      name: "ACTIONS",
      selector: (row) => {
        const DeleteAlert = () => {
          SetRowId(row);
          SetAlertDeletePopupType("success");
        };
        const CancelAlerrt = () => {
          SetAlertDeletePopupType("error");
        };

        const HandleDelete = async (rowObj) => {
          try {
            if (categorySecId) {
              const payload = {
                item_type: "category",
                item_ids: rowObj.id,
                source_type: rowObj.item_type === "promotional_category" ? "promotional_category" : "category"
              };

              await axiosConfig.post(
                `/cms/homepage_template/${categorySecId}/remove_items/`,
                payload
              );
            }

            SetAlertDeletePopupType("error");
            setDeletepopupType("success");
            await GetData();
            setTimeout(() => {
              getTemplate();
            }, 300);
          } catch (error) {
            setDeletepopupType("error");
            SetAlertDeletePopupType("error");
            console.error("Error deleting banner:", error);
          }
        };

        return (
          <>
            {!row.is_suspended ? (
              <div className="row">
                <div className="table-actions">
                  <button className="action-btn delete-btn" onClick={DeleteAlert}>
                    <MdDeleteOutline /> Delete
                  </button>
                </div>
              </div>
            ) : null}
            {AlertDeletePopupType === "success" && (
              <AlertDeletePopupModal
                AlertDeletePopupType={AlertDeletePopupType}
                HandleDelete={HandleDelete}
                CancelAlerrt={CancelAlerrt}
                row={RowId}
              />
            )}
          </>
        );
      },
    },
  ];
  const SectionDelete = async () => {
    try {
      await axiosConfig.delete(`/cms/homepage_template/${categorySecId}/`);
      SetMessage("Category template deleted successfully");
      setpopupType("success");
      // GetData();
      await getTemplate()
    } catch (error) {
      SetError("Error deleting Category template");
      setpopupType("error");
      console.error(error);
    }
  };
  const handleReviveSection = async () => {
    try {
      const response = await axiosConfig.post(
        `/cms/homepage_template/${categorySecId}/revive/`
      );
      setpopupType("success");
      SetMessage("Category section revived successfully");
      await GetData();
      await getTemplate()
    } catch (error) {
      SetError("Error while reviving category section");
      setpopupType("error");
      console.error("Revival error:", error);
    }
  };

  return (
    <>
      <div className="child-sidenav">
        <div className="childnav-content">
          <div className="text-block-end border-remove">
            <div className="text-block-border">
              <h5 className="dashboard-subtitle">Category Section</h5>

              <div className="d-flex gap-4">
                {!is_suspended ? (
                  <>
                    <MdKeyboardArrowUp />
                    <MdKeyboardArrowDown />
                    <FiSave
                      size={24}
                      onClick={handleSaveSelected}
                      style={{ cursor: "pointer" }}
                    />
                    <MdDelete
                      style={{ cursor: "pointer" }}
                      size={24}
                      onClick={SectionDelete}
                    />
                  </>
                ) : (
                  <FaHandHoldingHeart
                    size={24}
                    onClick={handleReviveSection}
                    style={{ cursor: "pointer", color: "green" }}
                  />
                )}
              </div>
            </div>

            <div className="col-md-4 sub-filter mt-3">
              <Select
                options={categoryOptions}
                placeholder="Select Category"
                isMulti={true}
                onChange={handleCategoryChange}
                value={selectedCategories}
              />
            </div>

            <div className="p-2">
              <div className="table-responsive">
                <DataTable
                  columns={columns}
                  data={Data}
                  pagination
                  paginationTotalRows={totalRows}
                  paginationPerPage={RowPerPage}
                  onSelectedRowsChange={handleRowSelected}
                  draggableColumns
                  paginationDefaultPage={currentPage}
                  customStyles={tableCustomStyles}
                  onChangePage={(page) => setCurrentPage(page)}
                  paginationPerPageOptions={[10, 20, 25, 30, 40, 50]}
                  paginationRowsPerPageOptions={[10, 20, 25, 30, 40, 50]}
                  onChangeRowsPerPage={(RowsPerPageChange) =>
                    setRowPerPage(RowsPerPageChange)
                  }
                  onSort={handleSort}
                  progressPending={loading}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {popupType && (
        <PopupModal
          popupType={popupType}
          setpopupType={setpopupType}
          Message={Message}
          error={Error}
        />
      )}
      {deletePopupType && (
        <DeletePopupModal
          setDeletepopupType={setDeletepopupType}
          deletePopupType={deletePopupType}
        />
      )}
      {modalShow && (
        <FileManager
          modalShow={modalShow}
          setModalShow={setModalShow}
          handleFile={handleImageChange}
          ismultiple={false}
          value="image_key"
        />
      )}
    </>
  );
};

export { CategorySection };
